import React from 'react';
import { connect } from 'react-redux';
import { LoadingIcon } from '_components'
import { CommonButton } from '_components';
import styles from './MiniSchedule.module.css';
import { PatientCareCenterNoteMiniScheduleHour } from './Hour';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dashboardActions } from '_actions';
import { bindActionCreators } from 'redux';
class PatientCareCenterNoteMiniSchedule extends React.Component {

    refreshSchedulesWithNotes() {
        const currentDate = new Date();
        this.props.loadTodaysSchedule();
        this.props.loadOutstandingNotes();
    }

    render() {
        let index = 0;
        return (
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    Schedule
                    <CommonButton className={styles.refresh_button} size='smaller' title='Refresh Schedule' onClick={() => this.refreshSchedulesWithNotes()}><FontAwesomeIcon icon={faRefresh} color="white"></FontAwesomeIcon></CommonButton>
                </div>
                <div className={styles.body}>
                    {this.props.loading &&
                        <div className={styles.loading_div}>
                            <br />
                            <label>Loading...</label>
                            <br /><br />
                            <LoadingIcon size='large' />
                        </div>
                    }
                    {!this.props.loading &&
                        <div>
                            {Object.keys(this.props.hours)
                                .map(id => {
                                    const hour = this.props.hours[id];
                                    return <PatientCareCenterNoteMiniScheduleHour key={hour} id={hour} isOdd={index++ % 2 === 0 ? false : true} />
                                })
                            }
                        </div>
                    }

                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadTodaysSchedule: bindActionCreators(dashboardActions.loadTodaysSchedule, dispatch),
        loadOutstandingNotes: bindActionCreators(dashboardActions.loadOutstandingNotes, dispatch),
    }
};

function mapStateToProps(state) {
    let appts = Object.keys(state.entities.dashboard.todaysSchedule)
        .sort((a, b) => {
            if (state.entities.dashboard.todaysSchedule[a].APTSTART !== state.entities.dashboard.todaysSchedule[b].APTSTART) {
                return state.entities.dashboard.todaysSchedule[a].APTSTART - state.entities.dashboard.todaysSchedule[b].APTSTART;
            } else if (state.entities.dashboard.todaysSchedule[a].APTSTART === state.entities.dashboard.todaysSchedule[b].APTSTART &&
                state.entities.dashboard.todaysSchedule[a].APTDURATION !== state.entities.dashboard.todaysSchedule[b].APTDURATION) {
                return state.entities.dashboard.todaysSchedule[a].APTDURATION - state.entities.dashboard.todaysSchedule[b].APTDURATION;
            } else {
                return state.entities.dashboard.todaysSchedule[a].APTID - state.entities.dashboard.todaysSchedule[b].APTID;
            }
        })
        .map(x => state.entities.dashboard.todaysSchedule[x].APTSTART);


    let firstHour = appts.length > 0 ? appts[0] / 3600000 : -1;
    let lastHour = appts.length > 0 ? appts[appts.length - 1] / 3600000 : -1;

    let hours = firstHour === -1 || lastHour === -1 ? [] : Array.from({ length: Math.floor((lastHour - firstHour) / .5) + 1 }, (v, k) => firstHour + (k * .5));

    return {
        loading: state.ui.dashboard.loadingTodaysSchedule,
        hours
    };
}

const connectedPatientCareCenterNoteMiniSchedule = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteMiniSchedule);
export { connectedPatientCareCenterNoteMiniSchedule as PatientCareCenterNoteMiniSchedule };

